import { render, staticRenderFns } from "./merge.vue?vue&type=template&id=3668a598&scoped=true&"
import script from "./merge.vue?vue&type=script&lang=js&"
export * from "./merge.vue?vue&type=script&lang=js&"
import style0 from "./merge.vue?vue&type=style&index=0&id=3668a598&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3668a598",
  null
  
)

export default component.exports